import { render, staticRenderFns } from "./PlaylistStudentThumbnail.vue?vue&type=template&id=5dec5d0b&scoped=true&"
import script from "./PlaylistStudentThumbnail.vue?vue&type=script&lang=ts&"
export * from "./PlaylistStudentThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./PlaylistStudentThumbnail.vue?vue&type=style&index=0&id=5dec5d0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dec5d0b",
  null
  
)

export default component.exports